import Nullstack from 'nullstack';
export default function IconBoxModelOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-box-model-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 8h4v4m0 4h-8v-8"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a1.994 1.994 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
  }), "   ", Nullstack.element("path", {
    d: "M16 16l3.3 3.3"
  }), "   ", Nullstack.element("path", {
    d: "M16 8l3.3 -3.3"
  }), "   ", Nullstack.element("path", {
    d: "M8 8l-3.3 -3.3"
  }), "   ", Nullstack.element("path", {
    d: "M8 16l-3.3 3.3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}